/* eslint-disable import/no-unresolved */
import * as React from 'react';
import './index.css';
import { withTranslation, i18nClient } from '@sailor/i18n-mach-pro';
import KNB from '@wmfe/mach-pro-knb';
import { throttle } from '@/src/utils/throttle';
import { buildUrl } from '@/src/utils/buildUrl';
import Constant from '@/src/utils/constant';
import CouponTipsView from '@/components/MultiSkuModal/Components/CouponTips';
import { MultiSkuModel } from '@/shop/shop_multi_sku_modal/component';
import MultiSpuLandscapeListView from '@/components/MultiSkuModal/Components/MultiSpuLandscapeListView';
import { SameShopSpuData, SameShopSpuItem } from '@/components/MultiSkuModal/Components/MultiSpuLandscapeListView/types';
import { containerHasChild, removeChildWithoutDestory } from '@/components/MultiSkuModal/utils/ui';
import { reportCodeTryException } from '@/src/common/exception';
import { getDefaultPreDecisionParams, preloadPayment } from '@/src/utils/payment';
import { shopMonitor } from '@/src/pages/shop/c_shop_golden/utils/Monitor';
import { ValidationRequest } from './Components/MultiSkuRequest/validationRequest';
import {
  Spu,
  ShopInfo,
  GoodDetailData,
  GoodDetailSkuList,
  GoodDetailGroupList,
  GoodDetailGroupSku,
  DefaultGoodDetail,
  DefaultGroupList,
  GoodDetailMinPrice,
  CouponTips,
} from '../../pages/shop/c_shop/component';
import GoodDetailFoodImage from './Components/FoodImage';
import AttrGroup from './Components/AttrGroup';
import SubmitBtn from './Components/SubmitBtn';
import Count from './Components/CountView';
import NavigationBar from './Components/Navigation';
import Remark from './Components/Remark';
import BottomToast from './Components/BottomToast';
import { orderRequest, TypeRequest, OrderRequest } from '../OrderRequest';
import { MULTI_SKU_ERROR_CODE, CHANGE_CART_SOURCE, CALCULATE_PRICE_STATUS } from '../../pages/shop/c_shop/utils/constant';
import CommonDialog from '../CommonDialog';
import { MultiSkuStore } from './Store';
import TrackUtils, { setTrackUserGetMode } from './utils/TrackUtils';
import { animationTemp } from '../../utils';
import { DynamicTagGroup } from '../DynamicTag';
import { MutliSKUModalMonitor, MULTI_SKU_MODAL_MONITOR_VALUE } from './utils/Monitor';
import {
  SOURCE_MULTI_SKU_NUM, SOURCE_ORDER_REQUEST, SHOP_ACTIVITY_TYPE, UserGetMode, ButtonType
} from './constant';
import DiscountTips from './Components/DiscountTips';
import { MultiSkuSource, SelectedSku } from './Store/model';
import IconText from '../IconText';
import { preloadPayComponent } from '../PayService/api';
import { ORDER_REQUEST_BODY } from '../OrderRequest/api';

const WMRouter = Mach.requireModule('Router');
const BackPressModule = Mach.requireModule('BackPressModule');
const Login = Mach.requireModule('Login');

interface IProps {
  setVisible: Function;
  shopInfo?: ShopInfo;
  addShopCart?: Function;
  shopId: string;
  brandId?: number;
  userActivityStatus?: number; // 用户是否享受过活动 0未享受 1已享受
  multiSkuModel?: MultiSkuModel;
  onError?: Function; //接口请求失败
  checkSpuFail?: Function; //一口价提单异常传参
  deleteUnavailableSku?: Function; //购物车浮层进入多规格，未在可售时间需要删除
}

interface IState {
  count: number; //份数
  curGoodDetail: GoodDetailData | undefined;
  couponTips: CouponTips | undefined;
  selectedSku: GoodDetailSkuList;
  totalPrice: {
    originPrice: GoodDetailMinPrice;
    discountPrice: GoodDetailMinPrice;
    currency: string;
  };
  readyToSubmit: boolean;
  scrollOffset: number;
  scrollerBottom: number; //用于适配iOS备注弹起键盘时不被遮挡
  showDialog: boolean;
  dialogMsg: {
    title: string;
    message?: string; // 提示文案
    leftText?: string; //左侧按钮默认点击后关闭选规格浮层
    rightText?: string; //右侧按钮默认关闭提示弹窗
    onClickLeftBtn?: VoidFunction;
    onClickRightBtn?: VoidFunction;
    onClickMask?: VoidFunction;
  };
  stickyTitle: boolean;
  /** 当前主sku是否满足满折 */
  curSkuIsMeetSillAmount: number;
  /** 当前主sku满足哪个阶梯的满折 */
  curSkuDiscountPriceIndex: number;
  isMoveAtTop: boolean;
}
const Toast = Mach.requireModule('Toast');
class MultiSkuModal extends React.Component<any, IState> {
  scroller: any | undefined = null;

  topHeight: number = Mach.env.statusBarHeight + Mach.env.screenHeight * 0.1; //用于计算必选品锚点

  tagLayouLab: { [key: number]: { x: number; y: number; width: number; height: number; }; } = {} //规格模块和布局位置映射(新增主规格skuId映射)

  tagViewLab: { [key: number | string]: boolean; } = {} //规格模块和埋点上报与否映射(新增主规格skuId上报)

  productCartIndex: number | undefined = undefined; //商品在购物车内的index，用于透传和区分入口

  defaultGoodData: DefaultGoodDetail| undefined = undefined; //购物车传进来的数据

  remarkY: number = 0; //备注布局Y

  remarkRef: any = React.createRef(); //备注ref

  firstRender: boolean = true; //是否首次渲染（曝光埋点用）

  store: MultiSkuStore = new MultiSkuStore();

  modalRef: any = React.createRef(); //蒙层ref

  goodDetailRef: any = React.createRef(); //containerref

  bottomToastRef: any = React.createRef(); // 底部满折菜toast ref

  modalHeight: number = 0; //浮层高度

  showModalAnim: boolean = false;

  submitLoading: boolean = false; //判断加购按钮是否在loading状态

  previewLoading: boolean = false; //判断preview接口是否在loading

  bottomBarHeight: number = 0; //系统底部导航条高度

  cartSkuList = [] as DefaultGoodDetail[]; //购物车内其他菜品数据

  multiSkuSource: MultiSkuSource = {
    sourceNum: SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW,
    orderRequestSource: SOURCE_ORDER_REQUEST.SHOP_CART_POPUP
  };

  source: number = 0; //入口来源：0 店铺卡片 1 一口价 2 购物车浮层 3 919活动落地页
  moduleSource: string | undefined; // 进入门店或多规格的某个模块来源（页面来源下的细分来源 比如：金刚落地页下挂菜卡片跳转 moduleSource为1）文档：https://km.sankuai.com/collabpage/1549078841

  limitCount: number | undefined; //折扣菜的限购份数
  shopNewUserLimitCount: number = 0; // 门店新客折扣菜限购份数
  normalDiscountLimitCount: number = 0; // 普通折扣菜限购份数

  lxSpuId: number | undefined; // 当前埋点的spuId

  // 资源位id
  resourceId?: string;
  // 活动id
  activityId?: string;

  userGetMode: UserGetMode = UserGetMode.delivery; // 用户取餐方式，默认是外卖

  mulitSkuModalMonitor: MutliSKUModalMonitor = new MutliSKUModalMonitor();

  backPressModuleId: any;
  requestSameShopSpuIdList: number[] = [] // 门店内同店铺spuId列表;
  sameShopSpuData: SameShopSpuData | undefined = undefined
  multiSpuLandscapeListViewWrapperRef: any = null
  spuDefaultImg: string = ''

  constructor(props: IProps) {
    super(props);
    this.state = {
      count: 1,
      curGoodDetail: undefined,
      couponTips: undefined,
      selectedSku: {} as GoodDetailSkuList,
      totalPrice: {
        originPrice: {} as GoodDetailMinPrice,
        discountPrice: {} as GoodDetailMinPrice,
        currency: '',
      },
      readyToSubmit: false,
      scrollerBottom: 50,
      dialogMsg: {
        title: '',
      },
      showDialog: false,
      stickyTitle: false,
      scrollOffset: 0,
      curSkuIsMeetSillAmount: 0,
      curSkuDiscountPriceIndex: 0,
      // 是否为吸顶状态：false为初始状态，true为吸顶
      isMoveAtTop: false,
    };
    this.bottomBarHeight = Mach.env.softMenuBarHeight;
  }

  /**
     * Modal展示
     */
  handleModalShow = () => {
    const keyFrames = {
      from: { opacity: 0 },
      to: { opacity: 1 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.modalRef?.setAnimation?.(animCartPopShow, () => { });
    // 关闭焦点的黑魔法，专门适配某些自动获取焦点的安卓手机
    if (Mach.env.isAndroid) {
      this.closeKeyBoard();
    }
  }

  /**
     * Modal消失
     */
  handleModalHidden = throttle(() => {
    const keyFrames = {
      from: { opacity: 0.8 },
      to: { opacity: 0 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.modalRef?.setAnimation?.(animCartPopShow, () => { });
    this.hiddenContainerAnim();
    setTimeout(() => { this.close(); }, 300);
  }, 300)

  showContainerAnim = () => {
    if (!this.showModalAnim) {
      return null;
    }
    const keyFrames = {
      from: { top: Mach.env.screenHeight },
      to: { top: 0 },
    };
    const animCartPopShow = animationTemp(keyFrames);
    this.goodDetailRef?.setAnimation?.(animCartPopShow, () => {});
    this.showModalAnim = false;
  }

  hiddenContainerAnim = () => {
    this.closeKeyBoard();
    this.showModalAnim = false;
    // 定位
    const keyFrames = {
      from: { top: 0 },
      to: { top: Mach.env.screenHeight },
    };
    const animCartPopHidden = animationTemp(keyFrames);
    this.goodDetailRef?.setAnimation?.(animCartPopHidden, (callback) => {
    });
  }

  onClickBottomToastShow = () => {
    this.bottomToastRef?.toastShow?.();
  }

  initMultiSkuSource = (originalSource: string | undefined, productCartIndex: number | undefined = undefined) => {
    if (originalSource === 'fixed-price') {
      this.multiSkuSource = {
        sourceNum: SOURCE_MULTI_SKU_NUM.FIXED_PRICE,
        orderRequestSource: SOURCE_ORDER_REQUEST.FIXED_PRICE,
      };
    } else if (originalSource === 'nine_one_nine') {
      this.multiSkuSource = {
        sourceNum: SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE,
        orderRequestSource: SOURCE_ORDER_REQUEST.NINE_ONE_NINE,
      };
    } else if (productCartIndex !== undefined) {
      this.multiSkuSource = {
        sourceNum: SOURCE_MULTI_SKU_NUM.SHOP_CART_POPUP,
        orderRequestSource: SOURCE_ORDER_REQUEST.SHOP_CART_POPUP,
      };
    } else {
      this.multiSkuSource = {
        sourceNum: Number(originalSource) || SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW,
        orderRequestSource: Number(originalSource) || SOURCE_ORDER_REQUEST.SHOP_CART_POPUP,
      };
    }
  }

  /**
     * 打开选规格浮层
     * 1.商品卡片入口
     * 2.购物车浮层入口（需要defaultGoodData和productCartIndex）
     * 3.一口价专区卡片入口（需要一口价标识）
     * @param spu
     * @param productCartIndex
     * @param defaultGoodData 购物车浮层默认商品信息
     * @param source // 入口来源： 0：门店列商品卡片列表、 1：一口价落地页、 2：门店购物车浮层、3：919活动落地页
     * @param moduleSource // 进入门店或多规格的某个模块来源（页面来源下的细分来源 比如：金刚落地页下挂菜卡片跳转 moduleSource为1）
     */

  public open(params: { spu?: Spu; productCartIndex?: number | undefined; defaultGoodData?: DefaultGoodDetail; source?: string; moduleSource?: string; cartSkuList?: any; resourceId?: string; activityId?: string; sameShopSpuIdList?: number[]; userGetMode?: UserGetMode; }) {
    // 资源位 id
    this.resourceId = params?.resourceId || '';
    // 活动 id
    this.activityId = params?.activityId || '';
    // 取货方式
    this.userGetMode = params?.userGetMode || UserGetMode.delivery;
    // 埋点使用
    setTrackUserGetMode(this.userGetMode);

    this.defaultGoodData = params.defaultGoodData;
    this.cartSkuList = params.cartSkuList;
    this.productCartIndex = params?.productCartIndex;
    this.initMultiSkuSource(params.source, params.productCartIndex);
    this.source = this.multiSkuSource.sourceNum;
    // 进入门店或多规格的某个模块来源(页面来源下的细分来源)
    this.moduleSource = params.moduleSource;
    this.lxSpuId = params?.spu?.spuId;
    if (params?.sameShopSpuIdList) {
      this.sameShopSpuData = undefined;
      this.requestSameShopSpuIdList = params?.sameShopSpuIdList || [];
    }
    this.spuDefaultImg = params?.spu?.picturesForSpec?.[0] || '';
    this.requestAPI(params?.spu);
  }

  public close() {
    this.props.setVisible(false);
  }

  componentDidMount(): void {
    this.tagViewLab = {};
    this.backPressModuleId = BackPressModule?.addBackPressListener(() => {
      this.handleModalHidden();
      return true;
      //return true; // 返回true时会阻止事件冒泡传递，因而不会执行默认的后退行为
      // return false; // 返回false时会使事件继续传递，触发其他注册的监听函数，或是系统默认的后退行为
    });
  }

  componentWillUnmount() {
    if (this.backPressModuleId) {
      BackPressModule?.removeBackPressListener(this.backPressModuleId);
    }
  }

  // 高达 lx 通参
  lxMARKETFLOADINGLAYERLab = () => {
    const multiSkuModel: MultiSkuModel = this.props.multiSkuModel;
    return {
      activity_id: multiSkuModel?.activity_id,
      componentInfo: multiSkuModel?.componentInfo,
      gd_page_id: multiSkuModel?.gdPageId,
      shop_brand_id: multiSkuModel?.brandId,
      shop_id: multiSkuModel?.shopId,
      spu_id: multiSkuModel?.spuId
    };
  }

  // 活动 加购 落地页
  lxSubmitBtnClickMv = () => {
    if ((this.source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) && this.props.multiSkuModel?.cid) {
      TrackUtils.gaodaMarketingFloatingLayerMV(this.lxMARKETFLOADINGLAYERLab(), this.props.multiSkuModel?.cid);
    }
  }

  // 活动 加购点击 落地页
  lxSubmitBtnClickMc = () => {
    if (this.props.multiSkuModel?.cid) {
      TrackUtils.gaodaMarketingFloatingLayerMC(this.lxMARKETFLOADINGLAYERLab(), this.props.multiSkuModel?.cid);
    } else {
      // 919活动结算按钮点击
      const skuId = this.state.selectedSku?.skuId ?? -999;
      const userStatus = this.getLxUserActivityStatus();
      const brandId = this.props.brandId ?? -999;
      TrackUtils.nineOneNineAddShopcartMC(skuId, userStatus, brandId);
    }
  }

  // 高达 落地页 POPUP
  lxPOPUPMv = (code) => {
    // 提示原因
    const remindReason = this.getLxRemindReason(code);

    if (this.props.multiSkuModel?.cid) {
      const lab = {
        ...this.lxMARKETFLOADINGLAYERLab(),
        remind_reason: remindReason
      };

      TrackUtils.gaodaMarketingPopUPMV(lab, this.props.multiSkuModel?.cid);
    } else {
      const { shopId, brandId = -999 } = this.props;
      const userStatus = this.getLxUserActivityStatus();

      TrackUtils.nineOneNineMultiSkuPopupViewMV(shopId, userStatus, brandId, remindReason);
    }
  }

  // 高达 落地页 POPUP
  lxPOPUPMc = (btnText: string, code,) => {
    const { shopId, brandId = -999 } = this.props;
    const userStatus = this.getLxUserActivityStatus();
    // 提示原因
    const remindReason = this.getLxRemindReason(code);

    const lab = {
      ...this.lxMARKETFLOADINGLAYERLab(),
      button_name: btnText,
      remind_reason: remindReason
    };

    if (this.props.multiSkuModel?.cid) {
      TrackUtils.gaodaMarketingPopUPMC(lab, this.props.multiSkuModel?.cid);
    } else {
      // 埋点
      TrackUtils.nineOneNineMultiSkuPopupViewMC(btnText, shopId, userStatus, brandId, remindReason);
    }
  }

  scrollToTop = () => { // 数据更新时需要自动滚动到头部
    if (this.scroller) {
      this.scroller?.scrollToOffset({ x: 0, y: 0 }, true);
    }
  }

  handleReportSameSpuView = (item: SameShopSpuItem, index: number) => {
    const lxlab = {
      sale_price: item.discountPrice?.amount || '-999',
      shop_id: this.props.shopId || '-999',
      spu_id: item.spuId,
      spu_index: index,
    };
    TrackUtils.multiSameSpuChangeMV(this.isFixedPriceSource(), lxlab);
  }

  handleChangeSpuClick = (item: SameShopSpuItem, index: number) => {
    const { curGoodDetail } = this.state;
    if (!item.spuId || curGoodDetail?.spuId === item.spuId) {
      return;
    }

    const lxlab = {
      sale_price: item.discountPrice?.amount || '-999',
      shop_id: this.props.shopId || '-999',
      spu_id: item.spuId,
      spu_index: index,
    };
    TrackUtils.multiSameSpuChangeClickMC(this.isFixedPriceSource(), lxlab);
    this.requestAPI({ spuId: item.spuId });
    this.scrollToTop();
  }
  renderMultiSpuView = () => {
    if (this.sameShopSpuData) {
      return (
        <view className="multi-spu-landscape-wrapper" ref={(ref) => { this.multiSpuLandscapeListViewWrapperRef = ref; }}>
          <view className="multi-spu-landscape" ref={(ref) => { this.multiSpuLandscapeViewRef = ref; }}>
            <MultiSpuLandscapeListView
              data={this.sameShopSpuData}
              currentSpuId={this.state.curGoodDetail?.spuId || 0}
              handleChangeSpuClick={this.handleChangeSpuClick.bind(this)}
              handleReportSpuView={this.handleReportSameSpuView.bind(this)}
            />
          </view>
        </view>
      );
    }
    return null;
  }

  multiSpuLandscapeStickTopWrapperRef: any = null
  multiSpuLandscapeViewRef: any = null
  preScrollDistance = 0; // 解决 iOS 中滑动回弹导致 scroll distance 为负数的问题
  offsetY = 0;
  originalMultiSpuLandscapeOffsetY = 0;
  performScrollForMultiSpuLandscapeListView = (offset) => {
    // 上拉时offset>0，下拉仅ios offset<0（bounce特性）
    if (offset.y >= 0) {
      // 正常判断
      this._performScrollForMultiSpuLandscapeListView(Math.round(offset.y));
    } else {
      // ios特判，取消头图从吸顶到初态出现的跳动
      if (this.preScrollDistance >= 0) {
        this._performScrollForMultiSpuLandscapeListView(0);
      }
    }
    this.preScrollDistance = offset.y;
  };

  _performScrollForMultiSpuLandscapeListView = (srollDistance) => {
    // 从初态到吸顶态需要走过的位移：头图高度
    let ceilingPoint = 0;
    const { curGoodDetail } = this.state;
    const imgUrl = curGoodDetail?.pictures?.[0];
    if (imgUrl) {
      const width = Mach.env.screenWidth;
      const height = (width * 3) / 4;
      ceilingPoint = height;
    }
    this.offsetY = srollDistance;
    if (this.multiSpuLandscapeListViewWrapperRef !== null) {
      if (srollDistance >= ceilingPoint) {
        // 超过吸顶点，执行吸顶操作
        this.handleUIChangeWhenScrollAtTop();
      } else {
        // 未超过吸顶点，当距离较近时先将吸顶区域隐藏/显示，避免出现跳动
        if ((srollDistance - ceilingPoint) > 2) {
          this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'hidden');
        } else {
          this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'visible');
        }

        // 未超过吸顶点，执行头图区域位移
        this.handleUIChangeWhenScroll();
      }
    }
  };

  // 保持吸顶态
  handleUIChangeWhenScrollAtTop = () => {
    if (this.multiSpuLandscapeViewRef && !containerHasChild(this.multiSpuLandscapeStickTopWrapperRef, this.multiSpuLandscapeViewRef)) {
      // this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'visible'); // 初始化时为隐藏态，触发吸顶才展示
      removeChildWithoutDestory(this.multiSpuLandscapeViewRef);
      this.multiSpuLandscapeStickTopWrapperRef?.appendChild(this.multiSpuLandscapeViewRef);
    }
    if (!this.state.isMoveAtTop) {
      this.setState({
        isMoveAtTop: true,
      });
    }
  };

  // 未吸顶时，头图和筛排器根据top移动
  handleUIChangeWhenScroll = () => {
    if (this.multiSpuLandscapeViewRef && !containerHasChild(this.multiSpuLandscapeListViewWrapperRef, this.multiSpuLandscapeViewRef)) {
      removeChildWithoutDestory(this.multiSpuLandscapeViewRef);
      this.multiSpuLandscapeListViewWrapperRef?.appendChild(this.multiSpuLandscapeViewRef);
      // this.multiSpuLandscapeStickTopWrapperRef?.style.setProperty('visibility', 'hidden'); // 初始化时为隐藏态，触发吸顶才展示
    }
    if (this.state.isMoveAtTop) {
      this.setState({
        isMoveAtTop: false,
      });
    }
  };

  render() {
    const {
      curGoodDetail, showDialog, selectedSku, count
    } = this.state;
    const { shopId, t, brandId = -999 } = this.props;
    if (!curGoodDetail) {
      return null;
    }
    const showMultiSpuLandscapeListView = Number(this.sameShopSpuData?.sameShopSpuList?.length) > 0;
    const top = Mach.env.statusBarHeight + 6;
    let maxHeight = Mach.env.screenHeight - top - this.bottomBarHeight;
    //非沉浸式状态栏高度默认为24，直接写固定值，最大高度需要减去状态栏的高度
    const defaultImmersiveStatusBarHeight = 24;
    if (!Mach.env.statusBarHeight) {
      maxHeight -= defaultImmersiveStatusBarHeight;
    }
    const lab = {
      picture_url: curGoodDetail.pictures,
      shop_id: shopId,
      spu_description: curGoodDetail.description,
      spu_id: curGoodDetail.spuId,
      sku_id: selectedSku?.skuId,
      source_page: this.source,
      sku_number: count
    };

    if (this.firstRender) {
      this.firstRender = false;
      let groupSkuCount = 0;
      if (this.defaultGoodData?.groupList && this.defaultGoodData?.groupList?.length > 0) {
        const groupList = this.defaultGoodData?.groupList;
        for (let i = 0; i < groupList.length; i++) {
          groupList[i].groupSkuList.map(() => (groupSkuCount += 1));
        }
      }
      //拉承一体多规格弹窗曝光
      if (this.source > SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
        TrackUtils.multiSkuModalPageMV(this.props.multiSkuModel, curGoodDetail, shopId, this.state.couponTips?.canUserCoupon, this.source);
      } else if (this.source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
        //919活动多规格弹窗曝光
        const userStatus = this.getLxUserActivityStatus();
        TrackUtils.nineOneNineMultiSkuPageMV(shopId, userStatus, brandId);
      } else {
        TrackUtils.multiSkuPageMV(this.isFixedPriceSource(), shopId, curGoodDetail, selectedSku, this.moduleSource);
      }
    }

    let submitBtnText = '';
    switch (true) {
      case this.productCartIndex !== undefined && count === 0:
        submitBtnText = t('shop_cartlayer_removeitem1');
        break;
      case this.productCartIndex !== undefined && count !== 0:
        submitBtnText = t('promodishes_update');
        break;
      default:
        submitBtnText = t('promodishes_add');
        break;
    }
    const backgroundColor = this.productCartIndex !== undefined ? 'transparent' : '#000000CC';
    const paddingBottom = this.store.getScreenBottom();
    // 默认不隐藏备注入口
    const hideRemark = curGoodDetail?.hideRemark === 1;
    const imgUrl = curGoodDetail?.pictures?.[0];
    this.originalMultiSpuLandscapeOffsetY = imgUrl ? Math.ceil((Mach.env.screenWidth * 3) / 4) : 0;
    return (
      <view
        className="modal"
        ref={(ref: any) => this.modalRef = ref}
        style={{
          width: Mach.env.screenWidth, height: Mach.env.screenHeight, backgroundColor, opacity: 0,
        }}
        onLayout={() => { this.handleModalShow(); }}
      >
        <view
          style={{
            top: Mach.env.screenHeight, width: Mach.env.screenWidth, height: Mach.env.screenHeight, backgroundColor: 'transparent'
          }}
          ref={(ref: any) => this.goodDetailRef = ref}
          onLayout={(frame) => {
            this.showModalAnim = true;
            if (!this.modalHeight) {
              this.showContainerAnim();
              this.modalHeight = frame.detail.height;
            }
          }}
          onClick={() => {
            this.handleModalHidden();
          }}
        >
          <view className="modal-container-wrapper" style={{ top, maxHeight }}>
            <view className="good-detail-close-area">
              <view className="good-detail-close-area-icon-wrapper">
                <image className="good-detail-close-area-icon" src="assets://shop/multi_sku_close_icon.png" />
              </view>
            </view>
            <view className="modal-container">
              <view className="good-detail-container">
                {/* scroller */}
                <scroller
                  style={{ width: Mach.env.screenWidth, flexDirection: 'column', backgroundColor: '#FFFFFF' }}
                  bounces={false}
                  showScrollIndicator={false}
                  ref={(ref: any) => { this.scroller = ref; }}
                  onScroll={(offset: any) => {
                    this.performScrollForMultiSpuLandscapeListView(offset);
                    if (!(Number(this.sameShopSpuData?.sameShopSpuList?.length) > 0)) {
                      this.showStickyTitle(offset.y);
                    }
                  }}
                >
                  <content className="scroller-content" style={{ paddingBottom: this.state.scrollerBottom }} onClick={this.closeKeyBoard}>
                    {/* 商家头部名称图片 */}
                    <view onLayout={(frame) => { this.topHeight = frame.detail.y + frame.detail.height; }}>
                      <GoodDetailFoodImage
                        curGoodDetail={curGoodDetail}
                        defaultImg={this.spuDefaultImg}
                        source={this.source}
                        renderMultiSpuView={showMultiSpuLandscapeListView ? this.renderMultiSpuView : undefined}
                        sameShopSpuListLength={this.sameShopSpuData?.sameShopSpuList?.length || 0}
                        // shopEntranceInfo
                      />
                    </view>
                    <view
                      className="seperator-line"
                      style={{ marginTop: 16, marginBottom: 16 }}
                      onLayout={(frame) => {
                        this.topHeight = frame.detail.y + frame.detail.height;
                      }}
                    />
                    {/* 规格选择区 */}
                    <view className="detail-content-group">
                      {/* sku组*/}
                      {this._renderSku()}
                      {/* 属性组*/}
                      {this._renderGroupList(lab)}
                    </view>
                    {hideRemark ? null : (
                      <>
                        <view className="seperator-line" />
                        <view onLayout={(frame) => { this.remarkY = frame.detail.y; }}>
                          <Remark
                            ref={this.remarkRef}
                            defaultRemark={this.defaultGoodData?.remark}
                            scrollToEdit={this.scrollUpRemark}
                            scrollToSubmit={this.scrollDowmRemark}
                          />
                        </view>
                      </>
                    )}
                  </content>
                </scroller>
                {showMultiSpuLandscapeListView && <view className="multi-spu-landscape-wrapper-stick-top" ref={(ref) => { this.multiSpuLandscapeStickTopWrapperRef = ref; }} />}
                {!showMultiSpuLandscapeListView && <NavigationBar goodsName={curGoodDetail.name} lab={lab} stickyTitle={this.state.stickyTitle} />}
                {/* footer */}
                {
                  // 是否是满折菜
                  selectedSku.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT && selectedSku.fullDiscountExtraInfo?.fullDiscountTips?.length
                    ? (
                      <DiscountTips
                        fullDiscountExtraInfo={selectedSku.fullDiscountExtraInfo}
                        onClickBottomToastShow={() => { this.onClickBottomToastShow(); }}
                      />
                    ) : null
                }
                {
                  selectedSku.activityInfoList?.[0]?.activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT && selectedSku.fullDiscountExtraInfo?.fullDiscountToast.length
                    ? (
                      <BottomToast
                        fullDiscountToast={selectedSku.fullDiscountExtraInfo?.fullDiscountToast}
                        ref={(ref: any) => {
                          this.bottomToastRef = ref;
                        }}
                        key={selectedSku.skuId}
                      />
                    ) : null
                }
                <view className="footer-view-container">
                  <CouponTipsView
                    source={this.source}
                    shopId={this.props.shopId}
                    multiSkuModel={this.props.multiSkuModel}
                    goodDetailData={curGoodDetail}
                    couponTips={this.state.couponTips}
                    originPrice={this.state.totalPrice.originPrice}
                    discountPrice={this.state.totalPrice.discountPrice}
                    onClickToShopPreview={() => { this.props.setVisible(false); }}
                  />

                  <view className="footer-view" style={{ paddingBottom }} onClick={() => {}}>
                    {/** 一口价、919活动不展示加购按钮 */}
                    {this.multiSkuSource.orderRequestSource === SOURCE_ORDER_REQUEST.SHOP_CART_POPUP
                                          && (
                                            <view className="btn-area">
                                              <Count defaultCount={this.defaultGoodData?.count} changeCount={this.changeCountNumber} lab={lab} count={count} />
                                            </view>
                                          )}
                    <view className="add-food-btn">
                      <SubmitBtn
                        totalPrice={this.state.totalPrice}
                        ready={this.state.readyToSubmit}
                        clickAddBtn={this.clickAddBtn}
                        btnText={submitBtnText}
                        showPrice={count !== 0}
                        source={this.source}
                        lxClickMv={this.lxSubmitBtnClickMv}
                      />
                    </view>
                  </view>
                </view>
                { showDialog && this._renderDialog()}
              </view>
            </view>
          </view>
        </view>
      </view>
    );
  }

  _renderSku = () => {
    const { curGoodDetail } = this.state;
    const { t } = this.props;
    if (!curGoodDetail) {
      return null;
    }
    let scrollerKey = 'scroller-con';
    (curGoodDetail.skuList || []).map((item: GoodDetailSkuList) => {
      scrollerKey += item.skuId;
    });
    /**
         * 先构造好数据
         * 1. 判断属于哪个阶梯的逻辑
         * 2. 动态标签展示的逻辑
         */
    return (
      <view className="sku-group" onLayout={(frame) => { this.topHeight += frame.detail.y + frame.detail.height; }}>
        <view className="group-content">
          <text className="group-title" content={t('cartlayer_select_spec')} />
          <view style={{ marginTop: 8, marginBottom: 16, width: '100%' }}>
            <scroller
              showScrollIndicator={false}
              className="activity-scroller"
              onscrollEnd={(offset: any) => {
                this.setState({
                  scrollOffset: offset.x
                });
              }}
              key={scrollerKey}
            >
              <content>
                {curGoodDetail.skuList.map((item: GoodDetailSkuList, index: number) => {
                  const highLight = this.itemIsSelected(item.skuId);
                  const { isMeetSillAmount, discountPriceIndex = 0 } = this.skuIsMeetSillAmount(item);
                  // 满折多阶梯，展示对应阶梯的价格和标签
                  const discountPriceList = item.discountPriceList || [];
                  const discountPriceText = discountPriceList[discountPriceIndex]?.discountPrice?.displayText;
                  const discountPricePromotionTags = discountPriceList[discountPriceIndex]?.promotionTags?.[0];
                  const border = highLight ? '2px solid #FFD900' : '2px solid #F7F7F7';
                  const backgroundColor = highLight ? '#FFFDEB' : '#F7F7F7';
                  const discountPrice = item.discountPrice ? item.discountPrice?.displayText : item.originPrice.displayText;
                  const originPrice = item.originPrice?.displayText;
                  const showOrigin = discountPrice !== originPrice;
                  const dynamicTag = item.promotionTags ? item.promotionTags[0].discountTag : undefined;
                  const lastItemIndex = curGoodDetail.skuList.length - 1;
                  const promotionTags = item.promotionTags?.[0];
                  if (this.tagLayouLab[item.skuId] && !this.tagViewLab[item.skuId]) {
                    this.onskuItemAppear(item);
                  }
                  return (
                  // eslint-disable-next-line react/jsx-key
                    <view
                      style={{
                        border, backgroundColor, marginLeft: index === 0 ? 16 : 8, marginRight: index === lastItemIndex ? 16 : 0
                      }}
                      className="group-item"
                      onClick={() => { this.clickSkuItem(index); }}
                      onLayout={(layout) => {
                        this.tagLayouLab[item.skuId] = layout.detail;
                        if (!this.tagViewLab[item.skuId]) {
                          this.onskuItemAppear(item);
                        }
                      }}
                    >
                      <text className="group-item-name" content={item.skuSpec} />
                      {item.calorie?.length > 0 && (
                        <IconText
                          iconSrc="assets://shop/icon_kcal_gray.png"
                          text={item.calorie}
                          containerStyle={{ marginTop: 6 }}
                        />
                      )}
                      {
                        // 参与满折活动
                        item.activityInfoList?.[0].activityType === SHOP_ACTIVITY_TYPE.FULL_DISCOUNT
                          ? (
                            <view className="group-item-discount-price-container">
                              <text className="group-item-price" content={originPrice} />
                              <view>
                                <view className="group-price-discount-container">
                                  <text
                                    className="group-price-discount-price-text"
                                    content={discountPriceText}
                                  />
                                  {/* 不满足满折多阶梯条件时展示 */}
                                  {!isMeetSillAmount && promotionTags?.discountTag ? <DynamicTagGroup {...promotionTags.discountTag} /> : null }
                                  {!isMeetSillAmount && promotionTags?.ruleTag ? <DynamicTagGroup {...promotionTags.ruleTag} /> : null }
                                  {/* 满足满折多阶梯条件时展示 */}
                                  {isMeetSillAmount && discountPricePromotionTags?.discountTag ? <DynamicTagGroup {...discountPricePromotionTags?.discountTag} /> : null }
                                  {isMeetSillAmount && discountPriceList.length > 1 && discountPricePromotionTags?.ruleTag ? <DynamicTagGroup {...discountPricePromotionTags?.ruleTag} /> : null }
                                </view>
                              </view>
                            </view>
                          )
                          : (
                            <view className="group-item-price-container">
                              <text className="group-item-price" content={discountPrice} />
                              {showOrigin && <text className="group-item-origin-price" content={originPrice} />}
                              {dynamicTag && <view style={{ marginLeft: 8, marginTop: Mach.env?.isAndroid ? 3 : 0 }}><DynamicTagGroup {...item.promotionTags[0].discountTag} /></view>}
                            </view>
                          )
                      }
                    </view>
                  );
                })}
              </content>
            </scroller>
          </view>
        </view>
      </view>
    );
  }

  _renderGroupList = (lab: any) => {
    const { curGoodDetail, curSkuIsMeetSillAmount, curSkuDiscountPriceIndex } = this.state;
    if (!curGoodDetail) {
      return null;
    }
    const selectedIndex = curGoodDetail.skuList.findIndex((item) => (item.skuId === this.state.selectedSku?.skuId));
    return (
      <view className="attr-group">
        {curGoodDetail?.skuList?.map((item: GoodDetailSkuList, index: number) => {
          if (item.groupList?.length > 0) {
            return selectedIndex === index && item.groupList.map((group: GoodDetailGroupList) => {
              if (this.tagLayouLab[group.groupId]) {
                this.onItemAppear(group);
              }
              const mustGroupList = this.store.getRequiredListBySkuId(this.state.selectedSku.skuId);
              const attrRef = mustGroupList.find((mustGroup) => mustGroup.groupId === group.groupId)?.ref;
              return (
              // eslint-disable-next-line react/jsx-key
                <view
                  onLayout={(frame) => {
                    this.tagLayouLab[group.groupId] = frame.detail;
                    this.onItemAppear(group);
                  }}
                >
                  <AttrGroup
                    ref={attrRef}
                    groupData={group}
                    changeSelectedAttrs={this.changeSelectedAttrs}
                    skuId={this.state.selectedSku.skuId}
                    isMeetSillAmount={curSkuIsMeetSillAmount}
                    curSkuDiscountPriceIndex={curSkuDiscountPriceIndex}
                    lab={lab}
                    store={this.store}
                    sku={item}
                  />
                </view>
              );
            });
          }
        })}
      </view>
    );
  }

  _renderDialog = () => {
    const { dialogMsg } = this.state;
    return (
      <CommonDialog
        title={dialogMsg.title}
        message={dialogMsg.message}
        leftBtnText={dialogMsg.leftText}
        rightBtnText={dialogMsg.rightText}
        onClickLeftBtn={dialogMsg.onClickLeftBtn ? dialogMsg.onClickLeftBtn : () => {
          this.setState({
            showDialog: false,
          });
        }}
        onClickRightBtn={dialogMsg.onClickRightBtn ? dialogMsg.onClickRightBtn : () => {
          this.setState({
            showDialog: false,
          });
        }}
        onClickMask={dialogMsg.onClickMask ? dialogMsg.onClickMask : () => {
          this.setState({
            showDialog: false,
          });
        }}
      />
    );
  }
  private showStickyTitle = (offsetY) => {
    const { curGoodDetail, stickyTitle } = this.state;
    if (offsetY >= (curGoodDetail?.pictures[0] ? Mach.env.screenWidth * 0.75 - 44 : 8)) {
      if (!stickyTitle) {
        this.setState({
          stickyTitle: true,
        });
      }
    } else {
      if (stickyTitle) {
        this.setState({
          stickyTitle: false,
        });
      }
    }
  }

  private requestAPI = (spu?: Spu) => {
    const {
      t, checkSpuFail, onError, shopId, deleteUnavailableSku
    } = this.props;
    let func: Function | undefined;
    switch (true) {
      case this.source === SOURCE_MULTI_SKU_NUM.SHOP_CART_POPUP:
        func = deleteUnavailableSku;
        break;
      case this.source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE:
      case this.source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE:
        func = checkSpuFail;
        break;
      default:
        func = onError;
        break;
    }
    let sameShopSpuIdList = this.requestSameShopSpuIdList;
    if (Number(this.sameShopSpuData?.sameShopSpuList?.length) > 0) { // 如果已经有数据，请求中不再携带参数值
      sameShopSpuIdList = [];
    }
    const param = {
      spuId: spu?.spuId || this.defaultGoodData?.spuId || 0,
      shopId,
      requestSource: this.source,
      couponInfo: this.props.multiSkuModel?.couponInfo,
      func,
      btnText: t('shop_cartlayer_clear2'),
      productCartIndex: this.productCartIndex,
      activityId: this.activityId,
      userGetMode: this.userGetMode,
      sameShopSpuIdList,
    };

    this.store.loadData(param, (isSuccess: boolean, curGoodDetail: GoodDetailData, code: number) => {
      if (isSuccess) {
        if (this.sameShopSpuData && curGoodDetail.spuId !== this.state.curGoodDetail?.spuId) {
          // 清除选中的规格
          this.store.clearSelectedList();
        }
        // 有新人折扣菜 + 有普通折扣菜
        const activityInfo = curGoodDetail.activityInfoList?.[0];
        const isDiscountSpu = activityInfo?.activityType === SHOP_ACTIVITY_TYPE.DISCOUNT_FOOD;
        this.shopNewUserLimitCount = Number(activityInfo?.extraInfo.shopNewUserLimitCount) || 0;
        this.normalDiscountLimitCount = Number(activityInfo?.extraInfo.normalDiscountLimitCount) || 0;
        const totalLimitCount = this.shopNewUserLimitCount + this.normalDiscountLimitCount;

        // 待删除limitCount
        // const limitActivityInfo = curGoodDetail.activityInfoList?.find((item) => ( item.activityType === 18 && (item.extraInfo.limitCount !== undefined )));
        // this.limitCount = Number(limitActivityInfo?.extraInfo?.limitCount);
        const cartSpuCount = this.store.spuCountInCart();
        const selectedSku = this.store.initDetailData(curGoodDetail.skuList, curGoodDetail?.chooseSkuId);
        const hideRemark = curGoodDetail?.hideRemark === 1;
        // 选择sku是否满折
        const isMeetSillAmount = selectedSku.fullDiscountExtraInfo?.isMeetSillAmount;
        // 选择sku满折所在阶梯
        const curSkuDiscountPriceIndex = this.handleCurSkuDiscountPriceIndex(selectedSku);
        if (Number(curGoodDetail?.sameShopSpuData?.sameShopSpuList?.length) > 0 && this.sameShopSpuData === undefined) {
          // 同店铺数据，仅在第一次请求时赋值
          this.sameShopSpuData = curGoodDetail.sameShopSpuData;
        }
        //后端算价
        this.setState({
          curGoodDetail,
          couponTips: curGoodDetail?.couponTips,
          selectedSku,
          count: this.defaultGoodData?.count || 1,
          totalPrice: {
            originPrice: curGoodDetail.minPrice,
            discountPrice: curGoodDetail.discountPrice,
            currency: curGoodDetail.minPrice.currency
          },
          readyToSubmit: this.store.verificateProducts(selectedSku),
          scrollerBottom: hideRemark ? 24 : 50,
          curSkuIsMeetSillAmount: isMeetSillAmount || 0,
          curSkuDiscountPriceIndex,
        });
        // 显示备注的时候去曝光
        if (!hideRemark) {
          TrackUtils.remarkMV(this.isFixedPriceSource(), this.props.shopId, curGoodDetail?.spuId);
        }
        //从卡片进来的话要弹限购逻辑哦
        // 新人折扣菜 shopNewUserLimitCount && 超过限购份数1份
        if (this.source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW && isDiscountSpu && this.shopNewUserLimitCount && cartSpuCount === this.shopNewUserLimitCount) {
          setTimeout(() => {
            Toast.show(i18nClient.getText('promodishes_limit_toast', { limit: this.shopNewUserLimitCount }), 2);
          }, 500);
        }
        // 新人折扣菜（可能为0） + 有普通折扣菜 normalDiscountLimitCount && 超过限购份数1份
        if (this.source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW && isDiscountSpu && this.normalDiscountLimitCount && cartSpuCount === totalLimitCount) {
          setTimeout(() => {
            Toast.show(i18nClient.getText('promodishes_mostamountoff', { amount: totalLimitCount }), 2);
          }, 500);
        }
        // 监控埋点
        this.multiSkuModalOpenRate(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, 0);
      } else {
        // 监控埋点
        this.multiSkuModalOpenRate(MULTI_SKU_MODAL_MONITOR_VALUE.FAILED, code ?? '-1');
      }
    }, this.defaultGoodData, this.cartSkuList);
  }

  /**
      * 打开多规格弹窗浮窗成功率监控
      */
  multiSkuModalOpenRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, code: number) => {
    const params = this.getMultiSkuModalMonitorCommonParam(code);
    this.mulitSkuModalMonitor?.multiSkuModalOpenRate(value, params);
  }

  /**
     * 菜品precheck接口成功率
     */
  multiSkuModalPrecheckRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, code: number) => {
    const params = this.getMultiSkuModalMonitorCommonParam(code);
    this.mulitSkuModalMonitor?.multiSkuModalPrecheckRate(value, params);
  }
  /**
     * 订单preview接口成功率
     */
  multiSkuModalPreviewRate = (value: MULTI_SKU_MODAL_MONITOR_VALUE, code: number) => {
    const params = this.getMultiSkuModalMonitorCommonParam(code);
    this.mulitSkuModalMonitor?.multiSkuModalPreviewRate(value, params);
  }
  /**
     * 监控埋点通用参数
     */
  getMultiSkuModalMonitorCommonParam = (code: number) => {
    const spuId = this.lxSpuId ?? '-1';
    const shopId = this.props.shopId ?? '-1';
    const orderSource = this.source ?? '-1';
    const activityId = this.activityId ?? '';
    const params = {
      spuId, shopId, orderSource, code, activityId
    };
    return params;
  }

  private findDefaultGroupData = (groupId: number): any => {
    const groupList: DefaultGroupList[] | undefined = this.defaultGoodData?.groupList;
    let defaultGroupData;
    if (groupList) {
      defaultGroupData = groupList.find((item) => item.groupId === groupId);
    }
    return defaultGroupData;
  }

  //点击选择sku的逻辑
  private clickSkuItem = (index: number) => {
    const { curGoodDetail, selectedSku } = this.state;
    const sku = curGoodDetail?.skuList[index];
    if (!curGoodDetail || !sku || sku === selectedSku) {
      return null;
    }
    //构造当前数据去请求购物车接口
    this.calculatePriceByBE(sku);
  }

  //判断当前item是否被选中
  private itemIsSelected = (skuId: number): boolean => (this.state.selectedSku && this.state.selectedSku.skuId === skuId)

  private handleCurSkuDiscountPriceIndex = (curSku: SelectedSku | GoodDetailSkuList): number => {
    let discountPriceIndex = 0;
    const isMeetSillAmount = curSku.fullDiscountExtraInfo?.isMeetSillAmount || 0;
    if (!isMeetSillAmount) {
      return discountPriceIndex;
    }
    // 满折所在阶梯金额
    const sillAmount = curSku.fullDiscountExtraInfo?.sillAmount?.amount || 0;
    (curSku.discountPriceList || []).forEach((discountPriceItem, i) => {
      if (discountPriceItem.sillAmount?.amount === sillAmount) {
        discountPriceIndex = i;
      }
    });
    return discountPriceIndex;
  }

  /**
     * 当前主sku是否满足满折条件 和 满折sku所在阶梯
     * @param curSku
     * @returns
     */
  private skuIsMeetSillAmount = (curSku: GoodDetailSkuList): { isMeetSillAmount: number; discountPriceIndex: number; } => {
    let isMeetSillAmount = 0;
    let discountPriceIndex = 0;
    this.store.selectedList.forEach((item) => {
      if (item.skuId === curSku.skuId) {
        // 每个主sku是否满折
        isMeetSillAmount = item.fullDiscountExtraInfo?.isMeetSillAmount || 0;
        // 满折所在阶梯index
        discountPriceIndex = this.handleCurSkuDiscountPriceIndex(item);
      }
    });

    return {
      isMeetSillAmount,
      discountPriceIndex
    };
  }

  //更新和存储已选group规格逻辑
  private changeSelectedAttrs = (groupId: number, groupSkuList: GoodDetailGroupSku[], func?: any) => {
    const { selectedSku } = this.state;
    this.calculatePriceByBE(selectedSku, undefined, undefined, groupId, groupSkuList, (res) => {
      if (res) { func(); }
    });
  }

  /**
     * 后端算价逻辑
     * @param selectedSkuData //已选择的sku
     * @param count //数量
     * @returns
     */

  private calculatePriceByBE = async (selectedSkuData: GoodDetailSkuList, countNumber?: number, purchaseType?: number, groupId?: number, groupSkuList?: GoodDetailGroupSku[], callback?: Function) => {
    if (this.store.getCalStatus() === CALCULATE_PRICE_STATUS.LOADING) {
      return;
    }
    const countTemp = (countNumber !== undefined) ? (purchaseType ? countNumber + 1 : countNumber - 1) : this.state.count;
    const cartSpuCount = this.store.spuCountInCart();
    const calData = this.store.createRequestData(selectedSkuData, countTemp, groupId, groupSkuList, this.props.multiSkuModel?.couponInfo, this.activityId);
    // const showLimitToast = type === 1 && this.limitCount && (this.limitCount + 1 === cartSpuCount + countTemp);
    const totalLimitCount = this.shopNewUserLimitCount + this.normalDiscountLimitCount;
    const showShopNewUserLimitToast = purchaseType === ButtonType.ADD && this.shopNewUserLimitCount && (this.shopNewUserLimitCount + 1 === cartSpuCount + countTemp);
    const showNormalDiscountLimitToast = purchaseType === ButtonType.ADD && this.normalDiscountLimitCount && (totalLimitCount + 1 === cartSpuCount + countTemp);

    try {
      const res = await this.store.calByBE(calData);
      // 超出折扣菜库存Toast
      // const overStockToast = res.activityPopType === 1 && res.activityPopText;
      this.store.changeCalStatus(CALCULATE_PRICE_STATUS.SUCCESS);
      const fullDiscountExtraInfo = res.fullDiscountExtraInfo;
      const selectedSku = { ...selectedSkuData, fullDiscountExtraInfo };
      // 选择sku满折所在阶梯
      const curSkuDiscountPriceIndex = this.handleCurSkuDiscountPriceIndex(selectedSku);
      this.store.changeSelectedList(selectedSkuData.skuId, fullDiscountExtraInfo);
      this.setState({
        selectedSku,
        couponTips: res.couponTips,
        totalPrice: {
          discountPrice: res.discountPrice,
          currency: res.discountPrice?.currency,
          originPrice: res.originPrice,
        },
        count: countTemp,
        readyToSubmit: this.store.verificateProducts(selectedSkuData),
        curSkuIsMeetSillAmount: fullDiscountExtraInfo?.isMeetSillAmount || 0,
        curSkuDiscountPriceIndex,
      }, () => {
        // 展示新人折扣菜toast：有新人折扣菜 shopNewUserLimitCount && 超过限购份数1份
        if (showShopNewUserLimitToast) {
          Toast.show(i18nClient.getText('promodishes_limit_toast', { limit: this.shopNewUserLimitCount }), 2);
        }
        // 展示普通折扣菜toast：新人折扣菜（可能为0） + 有普通折扣菜 normalDiscountLimitCount && 超过限购份数1份
        if (showNormalDiscountLimitToast) {
          Toast.show(i18nClient.getText('promodishes_mostamountoff', { amount: totalLimitCount }), 2);
        }
      });
      callback ? callback(true) : null;
    } catch (error: any) {
      this.store.changeCalStatus(CALCULATE_PRICE_STATUS.ERROR);
      this.showRequestError(error);
      // 捕获到异常上报
      reportCodeTryException({
        message: 'calculatePriceByBE',
        extra: error
      });
    }
  }

  /**
     * 网络请求系统异常的toast
     */
  private showRequestError = (error, hasShowedDialog = false) => {
    const { t, checkSpuFail } = this.props;
    if (error.code === MULTI_SKU_ERROR_CODE.STYSTEMERROR) {
      Toast.show(t('shouye_default_4'), 2, {
        type: 'B', // 异常类型，B为后端异常
        code: error.code || '0', // 异常码
        extraInfo: {
          msg: error.message,
          method: 'ValidationRequest',
        }, // 附加异常信息
      });
      this.submitLoading = false;
    } else {
      this.submitLoading = false;
      if (!hasShowedDialog) {
        Toast.show(this.isFixedPriceSource() ? t('fixprice_default') : error.message, 2);
      }
      // 若一人食中已经展示了Dialog，则已经在perCheck校验接口中处理了，这里不再处理
      if (this.isFixedPriceSource()) {
        if (!hasShowedDialog) {
          setTimeout(() => { checkSpuFail(this.state.curGoodDetail?.spuId); }, 2000);
        }
      } else {
        setTimeout(() => { this.handleModalHidden(); }, 2000);
      }
    }
  }

  //加购按钮点击
  private clickAddBtn = () => {
    if (this.submitLoading) {
      return;
    }
    if (this.state.count === 0) {
      this.deleteShopCartItem();
    } else {
      if (this.state.readyToSubmit) {
        this.addToShopcartParams();
      } else {
        this.anchorMustGroup();
      }
    }
  }

  /**
     * 获取灵犀埋点用户活动状态
     * @returns
     */
  getLxUserActivityStatus = () => {
    const { userActivityStatus } = this.props;
    // 1 活动新客 2 活动老客
    return userActivityStatus === 0 ? 1 : 2;
  }

  /**
     * 获取灵犀埋点弹窗原因
     */
  getLxRemindReason = (code) => {
    const reason = {
      [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE]: 1, // 活动已结束
      [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK]: 2, // 无库存
      [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE]: 3, // 重复购买
      [MULTI_SKU_ERROR_CODE.SHOP_PRODUCT_OFF]: 1, // 商品下架删除
      [MULTI_SKU_ERROR_CODE.SHOP_REST]: 2, // 商家打烊
    };
    const reasonCode = reason?.[code] ?? -999;
    return reasonCode;
  }

  //加购到购物车
  private addToShopcartParams = () => {
    const {
      selectedSku, curGoodDetail, count, totalPrice
    } = this.state;
    if (!curGoodDetail) {
      return null;
    }

    //拉承一体多规格弹窗结算按钮点击
    if (this.source > SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
      TrackUtils.multiSkuModalCheckoutMC(
        this.props.multiSkuModel,
        curGoodDetail,
        this.props.shopId,
        this.state.selectedSku?.skuId,
        this.state.couponTips?.canUserCoupon,
        this.source,
        totalPrice.originPrice?.displayAmount,
        totalPrice.discountPrice?.displayAmount
      );
    } else if (this.source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
      this.lxSubmitBtnClickMc();
    } else {
      TrackUtils.addShopcartMC('sailor_c', this.isFixedPriceSource(), this.state.totalPrice, this.props.shopId, selectedSku, count, curGoodDetail);
    }
    this.validRequest();
  }

  private getOrderData = (): any => {
    const { selectedSku, curGoodDetail, count } = this.state;
    //为兼容历史逻辑后端要求搞两套
    const groupSkuReqIDs: {groupSkuId: number; count: number;}[] = [];
    const groupSkuIDs: number[] = [];
    let remark = '';
    const { current } = this.remarkRef || {};
    if (current) {
      remark = current.inputText();
    } else {
      remark = this.defaultGoodData?.remark || '';
    }
    const selectedSkuGroupList = this.store.getSelectedGroupListBySkuId(selectedSku.skuId);
    for (let i = 0; i < selectedSkuGroupList.length; i++) {
      const seGroupList = selectedSkuGroupList[i].groupSkuList;
      if (seGroupList && seGroupList.length > 0) {
        seGroupList.forEach((item) => {
          groupSkuReqIDs.push({ groupSkuId: item?.groupSkuId, count: item?.count });
          groupSkuIDs.push(item?.groupSkuId);
        });
      }
    }
    const locationObj = Mach.requireModule('SLLocation')?.getLocation();
    // 来源标识 1 一口价 3 919活动落地页 其他默认 0 店铺卡片
    const source = this.multiSkuSource.orderRequestSource;
    return {
      shopId: this.props.shopId,
      latitude: locationObj.latitude,
      longitude: locationObj.longitude,
      orderSource: source,
      requestSource: source,
      spuId: curGoodDetail?.spuId,
      skuList: [{
        skuId: selectedSku?.skuId,
        count,
        remark,
        groupSkuList: groupSkuIDs,
        groupSkuReqList: groupSkuReqIDs,
      }],
      [ORDER_REQUEST_BODY.finParam]: JSON.stringify(getDefaultPreDecisionParams())
    };
  }

  /* 锚点 */
  private anchorMustGroup = () => {
    console.log('KNB.vibrate', KNB.vibrate);
    const skuId = this.state.selectedSku.skuId;
    const mustGroupList = this.store.getRequiredListBySkuId(skuId);
    const shouldHightLightList = this.store.getHighlightGroupBySkuId(skuId);
    const shouldScrollY = this.topHeight + Mach.env.statusBarHeight + Mach.env.screenHeight * 0.1;
    if (shouldHightLightList && shouldHightLightList.length) {
      //震动
      KNB.vibrate({
        duration: 1000,
      });
      //变颜色
      const anchorGroupId = shouldHightLightList[0];
      shouldHightLightList.forEach((item) => {
        const attrRef = mustGroupList.find((mustGroup) => mustGroup.groupId === item)?.ref;
        const { current } = attrRef || {};
        if (current) {
          current.hightLightBg();
        }
      });
      //锚点
      if (this.tagLayouLab && this.tagLayouLab[anchorGroupId]) {
        const { y } = this.tagLayouLab[anchorGroupId];
        if (y + shouldScrollY < Mach.env.screenHeight / 2) {
          this.scroller?.scrollToOffset({ x: 0, y: 0 }, true);
        } else {
          this.scroller?.scrollToOffset({ x: 0, y: y + shouldScrollY - Mach.env.screenHeight / 2 }, true);
        }
      }
    }
  }

  /** 校验接口 */
  private validRequest = () => {
    this.submitLoading = true;
    const { t, checkSpuFail, addShopCart } = this.props;
    const { selectedSku, curGoodDetail, count } = this.state;
    const orderObj = this.getOrderData();
    const sku = orderObj.skuList[0];
    delete orderObj.skuList;
    const param = {
      ...orderObj,
      ...sku,
      userGetMode: this.userGetMode,
    };
    const shopCartSku = {
      skuId: selectedSku?.skuId,
      name: curGoodDetail?.name,
      picture: curGoodDetail?.pictures?.length ? curGoodDetail?.pictures[0] : ' ',
      originPrice: selectedSku?.originPrice,
      spuId: curGoodDetail?.spuId,
      count,
      remark: param.remark,
      skuSpec: selectedSku?.skuSpec,
      groupList: this.store.getSelectedGroupListBySkuId(selectedSku?.skuId),
    };
    const errCodes = [
      MULTI_SKU_ERROR_CODE.SHOP_REST,
      MULTI_SKU_ERROR_CODE.SHOP_OFFLINE,
      MULTI_SKU_ERROR_CODE.NO_INVENTORY,
      MULTI_SKU_ERROR_CODE.UNAVAILABLE,
      MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE,
      MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE,
      MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK,
      MULTI_SKU_ERROR_CODE.UN_SELECTED_REQUIRED_PRODUCT,
    ];

    ValidationRequest(param, t('shop_cartlayer_clear2'), {}, checkSpuFail)
      .then((res) => {
        // 监控埋点(一口价&919活动落地页&其它活动页)
        if (this.multiSkuSource.orderRequestSource > SOURCE_ORDER_REQUEST.SHOP_CART_POPUP) {
          this.multiSkuModalPrecheckRate(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, 0);
        }
        //酒类
        if (res.riskCheckTip) {
          this.submitLoading = false;
          this.setState({
            showDialog: true,
            dialogMsg: {
              title: res.riskCheckTip,
              rightText: t('shop_cartlayer_clear2'),
            },
          });
          return false;
        } else if (res.alcoholInfo?.hasAlcohol) {
          this.submitLoading = false;
          this.setState({
            showDialog: true,
            dialogMsg: {
              title: res.alcoholInfo.alcoholTips,
              leftText: res.alcoholInfo.cancelText,
              rightText: res.alcoholInfo.confirmText,
              onClickRightBtn: () => {
                this.setState({
                  showDialog: false,
                  dialogMsg: {
                    title: '',
                    leftText: '',
                    rightText: '',
                  }
                }, () => {
                  if (!this.previewLoading) {
                    this.orderRequest(this.getOrderData(), errCodes);
                  }
                });
              },
            },
          });
        } else {
          //门店预览和购物车浮层来源时，点击按钮是直接加购
          if (this.multiSkuSource.orderRequestSource === SOURCE_ORDER_REQUEST.SHOP_CART_POPUP) {
            addShopCart({ sku: shopCartSku, productCartIndex: this.productCartIndex, addCartSource: CHANGE_CART_SOURCE.MULTI_MODAL });
            this.handleModalHidden();
          } else {
            // 一口价及919活动及其它活动调用preview接口
            this.submitLoading = true;
            this.previewLoading = false;
            this.orderRequest(this.getOrderData(), errCodes);
          }
        }
      }, (error) => {
        // 在 preCheck 接口中，如果返回的是 string 类型的 error，说明已经进行了弹窗提示，不需要再次进行其他提示
        let hasShowedDialog = false;
        if (typeof error === 'string') {
          hasShowedDialog = true;
        }
        this.showRequestError(error, hasShowedDialog);
        // 监控埋点
        this.multiSkuModalPrecheckRate(MULTI_SKU_MODAL_MONITOR_VALUE.FAILED, error?.code ?? '-1');
      })
      .catch((error) => {
        console.log('validRequestError', error);
      });
  }

  //请求preview
  private orderRequest = (orderRequestParams: OrderRequest, errCodes: number[]) => {
    if (this.previewLoading) {
      return;
    }
    this.submitLoading = true;
    this.previewLoading = true;

    // 需要 传入活动 id 与资源 id
    if (this.activityId || this.resourceId) {
      if (orderRequestParams.extra) {
        orderRequestParams.extra.activityId = this.activityId;
        orderRequestParams.extra.resourceId = this.resourceId;
      } else {
        orderRequestParams.extra = {
          activityId: this.activityId,
          resourceId: this.resourceId
        };
      }
    }

    orderRequest(orderRequestParams, TypeRequest.PREVIEW, errCodes)
      .then((result) => {
        if (result) {
          preloadPayment(result);

          shopMonitor.reportMetrics({
            FrontPaymentPreloadRate: 1
          }, {
            ...shopMonitor.defaultTags,
            status: 1,
            source: 'multi-sku'
          });

          this.gotoOrderConfirmPage(result);//点击提单无效
        } else {
          this.submitLoading = false;
          this.previewLoading = false;
        }
        this.multiSkuModalPreviewRate(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, 0);
      }, (result) => {
        this.submitLoading = false;
        this.previewLoading = false;
        // 处理919活动异常Case弹窗
        const { code, message } = result || {};
        if (code === MULTI_SKU_ERROR_CODE.SHOP_REST || code === MULTI_SKU_ERROR_CODE.SHOP_PRODUCT_OFF) {
          this.showPreviewCommonDialog(code, message);
        } else if (code === MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE
                    || code === MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK
                    || code === MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE) {
          this.handleNineOneNineActivityDialog(code, message);
        } else if (code === MULTI_SKU_ERROR_CODE.UN_SELECTED_REQUIRED_PRODUCT) {
          this.handleUnSelectedRequiredProduct(message);
        } else if (this.source <= SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
          //source 大于3时，多规格弹窗一个单独弹窗容器加载，异常时不需要关闭多规格弹窗
          let hiddenModal = true;
          if (this.source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE) {
            // 一人食落地页 未登录状态下不需要关闭多规格弹层
            const isLogin = Login?.isLogin?.();
            if (!isLogin) {
              hiddenModal = false;
            }
          }
          if (hiddenModal) {
            this.handleModalHidden();
          }
        }
        this.multiSkuModalPreviewRate(MULTI_SKU_MODAL_MONITOR_VALUE.FAILED, code ?? '-1');
      });
  }

  /**
     * 高达搭建营销落地页来源时，弹必选菜未选择弹窗时，点击确认按钮需要跳转至对应的门店预览页并锚点到当前商品
     * @param message
     */
  // 有必选菜 逻辑,需要
  handleUnSelectedRequiredProduct = (message) => {
    let promptMsg;
    if (this.source <= SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
      //source 大于3时，多规格弹窗一个单独弹窗容器加载，异常时不需要关闭多规格弹窗
      this.handleModalHidden();
      promptMsg = message || i18nClient.getText('shouye_default_4');
    } else {
      promptMsg = i18nClient.getText('newerpage_guige_mustchoose_tips');
    }
    const Dialog = Mach.requireModule('Dialog');
    Dialog?.show({
      level: 1,
      title: promptMsg,
      rightButtonTitle: i18nClient.getText('shop_cartlayer_clear2')
    }, (res: any) => {
      if (res.which === -1 && this.source > SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE) {
        // 点击右边按钮
        //跳转至对应的门店预览页并锚点到当前商品
        const shopId = this.props.shopId;
        const spuId = this.state.curGoodDetail?.spuId || 0;
        const categoryId = this.state.curGoodDetail?.firstCategoryId || 0;
        const shopScheme = `sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_shop&spuId=${spuId}&categoryId=${categoryId}&shopId=${shopId}&orderSource=${this.source}`;
        WMRouter.navigateTo(shopScheme, {}, (result) => { this.close(); });
      }
    });
  }

  // 显示单按钮弹窗
  showPreviewCommonDialog = (code, message) => {
    const { t, shopId = -999, brandId = -999 } = this.props;
    // 用户活动状态
    const userStatus = this.getLxUserActivityStatus();
    // 获取弹窗原因
    const remindReason = this.getLxRemindReason(code);
    this.setState({
      showDialog: true,
      dialogMsg: {
        title: '',
        message,
        rightText: t('shop_cartlayer_clear2'),
        onClickRightBtn: () => {
          this.setState({
            showDialog: false,
            dialogMsg: {
              title: '',
              message: '',
            },
          }, () => {
            // 关闭规格弹窗
            this.handleModalHidden();
            // 弹窗点击事件
            TrackUtils.previewCommonDialogMC(this.source, shopId, userStatus, brandId, remindReason);
          });
        },
        onClickMask: () => {},
      },
    });
    // 弹窗曝光
    TrackUtils.previewCommonDialogMV(this.source, shopId, userStatus, brandId, remindReason);
  }

  // 处理919活动异常Case弹窗
  handleNineOneNineActivityDialog = (code, message) => {
    const errCodes = [MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_INVALIDATE, MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OUT_OFF_STOCK, MULTI_SKU_ERROR_CODE.NINE_ONE_NINE_OFFLINE];
    if (!errCodes.includes(code) || message?.length === 0) {
      return;
    }
    const title = i18nClient.getText('mkt_promo_activitynomore');
    const leftText = i18nClient.getText('mkt_promo_return');
    const rightText = i18nClient.getText('mkt_promo_browsestore');
    const { shopId, brandId = -999 } = this.props;
    const userStatus = this.getLxUserActivityStatus();
    // 提示原因
    const remindReason = this.getLxRemindReason(code);
    this.setState({
      showDialog: true,
      dialogMsg: {
        title,
        message,
        leftText,
        rightText,
        onClickLeftBtn: () => {
          this.setState({
            showDialog: false,
            dialogMsg: {
              title: '',
              message: '',
            },
          });
          // 返回首页
          this.handleModalHidden();
          WMRouter.navigateTo(Constant.HOME_PAGE);
          this.lxPOPUPMc(leftText, code);
        },
        onClickRightBtn: () => {
          this.setState({
            showDialog: false,
            dialogMsg: {
              title: '',
              message: '',
            },
          }, () => {
            // 跳转到店铺页
            this.handleModalHidden();
            const url = buildUrl(Constant.SHOP_PAGE, { shopId: this.props.shopId });
            WMRouter.navigateTo(url, null, () => {});
            this.lxPOPUPMc(rightText, code);
          });
        },
        onClickMask: () => {},
      },
    });

    // 弹窗曝光
    this.lxPOPUPMv(code);
  }

  //跳转提单页
  private gotoOrderConfirmPage = (orderResponse: any) => {
    const multiSkuModel: MultiSkuModel = this.props.multiSkuModel || {};
    const WMRouter = Mach.requireModule('Router');
    const bundleName = 'mach_pro_sailor_c_order_confirm';
    const orderResponseParams = encodeURIComponent(JSON.stringify(orderResponse));
    let urlScheme = `sailorc://keeta.com/machpro?mach_bundle_name=${bundleName}&order_info=${orderResponseParams}`;
    if (this.activityId || this.resourceId) {
      urlScheme = `sailorc://keeta.com/machpro?mach_bundle_name=${bundleName}&order_info=${orderResponseParams}&activity_id=${this.activityId}&resource_id=${this.resourceId}`;
    }

    // 添加归因信息
    if (multiSkuModel?.attributionInfo) {
      urlScheme = `${urlScheme}&attributionInfo=${encodeURIComponent(multiSkuModel.attributionInfo)}`;
    }

    WMRouter.navigateTo(urlScheme, {}, (result: any) => {
      if (result.success) {
        this.close();
      } else {
        this.previewLoading = false;
        this.submitLoading = false;
        Toast.show(i18nClient.getText('shouye_default_4'), 2, {
          code: result?.error?.code || '0',
          extraInfo: {
            ...result,
            url: urlScheme,
            msg: 'gotoOrderConfirmPage跳转提单页失败',
          },
        });
      }
    });
  }

  /**
     * 改变加购数量
     * @param count 数量
     * @param purchaseType  0 减购 1 加购
     */
  private changeCountNumber = (count: number, purchaseType: number) => {
    this.calculatePriceByBE(this.state.selectedSku, count, purchaseType);
  }

  /**
     * 删除当前菜品（从购物车浮层进来的，可以减购到0）
     */
  private deleteShopCartItem = () => {
    const { deleteUnavailableSku } = this.props;
    if (this.productCartIndex !== undefined) {
      deleteUnavailableSku(this.productCartIndex);
      this.handleModalHidden();
    }
  }

  //关闭备注页的键盘
  private closeKeyBoard = () => {
    const { current } = this.remarkRef || {};
    if (current) {
      current.inputBlur?.();
    }
  }

  private scrollUpRemark = () => {
    TrackUtils.remarkMC(this.isFixedPriceSource(), this.props.shopId, this.state.selectedSku.skuId);
    if (this.scroller) {
      this.setState({
        scrollerBottom: 270 - this.bottomBarHeight,
      }, () => {
        setTimeout(() => {
          this.scroller?.scrollToOffset({ x: 0, y: this.remarkY }, true);
        }, 100);
      });
    }
  }

  private scrollDowmRemark = () => {
    if (this.scroller) {
      this.setState({
        scrollerBottom: 50,
      }, () => {
        this.scroller?.scrollToOffset({ x: 0, y: this.remarkY }, true);
      });
    }
  }

  private isFixedPriceSource = () => this.source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE

  //规格模块曝光埋点
  private onItemAppear = (groupData: GoodDetailGroupList) => {
    const { curGoodDetail, selectedSku } = this.state;
    const groupSkuCount = this.defaultGoodData ? this.findDefaultGroupData(groupData.groupId)?.length : 0;
    const ruleTag = selectedSku?.promotionTags?.[0]?.ruleTag?.tags?.[0].subTags?.[1]?.text || '';
    const discountPrice = selectedSku?.discountPrice?.displayAmount || '';
    const activityType = selectedSku?.activityInfoList?.[0]?.activityType || 0;
    // 组件高度 + 上方图片及sku的高度 - 滚动距离 < 浮层高度 - 购物车高度
    if (!this.tagViewLab[groupData.groupId]) {
      this.tagViewLab[groupData.groupId] = true;
      TrackUtils.attrGroupMV(
        this.isFixedPriceSource(),
        this.props.shopId,
        curGoodDetail?.spuId || 0,
        groupSkuCount,
        groupData.groupName,
        ruleTag,
        discountPrice,
        activityType
      );
    }
  }

  private onskuItemAppear = (sku: GoodDetailSkuList) => {
    const { x } = this.tagLayouLab[sku.skuId];
    const offset = this.state.scrollOffset || 0;
    if (x - offset <= Mach.env.screenWidth - 16) {
      this.tagViewLab[sku.skuId] = true;
      TrackUtils.variationMV(this.isFixedPriceSource(), sku.extraInfo?.logData, sku.calorie);
    }
  }
}

export default withTranslation('', {
  withRef: true,
})(MultiSkuModal);
